/**
 * The fifteen towns of Barnstable County, for the Start onboarding dialog's
 * town select. A town, never a village: Hyannis is Barnstable, Dennis Port is
 * Dennis, which is also what the profile's Property section asks for.
 *
 * Local until the contracts publish a town list (noted for CAP-1484); the
 * community impact fee towns in `MA_COMMUNITY_IMPACT_FEE_TOWNS` are a subset.
 */
export const CAPE_COD_TOWNS = [
  'Barnstable',
  'Bourne',
  'Brewster',
  'Chatham',
  'Dennis',
  'Eastham',
  'Falmouth',
  'Harwich',
  'Mashpee',
  'Orleans',
  'Provincetown',
  'Sandwich',
  'Truro',
  'Wellfleet',
  'Yarmouth',
] as const
